/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the normality of a concentrated liquid reagent such as an acid or base. Enter its density, assay (purity) and equivalent weight, and leave the value you want to find blank.`)
};

const es_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la normalidad de un reactivo líquido concentrado, como un ácido o una base. Introduce su densidad, ensayo (pureza) y peso equivalente, y deja en blanco el valor que quieras calcular.`)
};

const de_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmen Sie die Normalität eines konzentrierten flüssigen Reagenzes wie einer Säure oder Base. Geben Sie Dichte, Gehalt (Reinheit) und Äquivalentgewicht ein und lassen Sie den gesuchten Wert leer.`)
};

const nl_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de normaliteit van een geconcentreerd vloeibaar reagens zoals een zuur of base. Vul de dichtheid, het gehalte (zuiverheid) en het equivalentgewicht in, en laat de waarde die je wilt berekenen leeg.`)
};

const fr_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez la normalité d'un réactif liquide concentré tel qu'un acide ou une base. Entrez sa densité, son titre (pureté) et son équivalent-gramme, et laissez vide la valeur que vous souhaitez trouver.`)
};

const it_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova la normalità di un reagente liquido concentrato come un acido o una base. Inserisci densità, titolo (purezza) e peso equivalente, e lascia vuoto il valore che vuoi trovare.`)
};

const pt_br2_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a normalidade de um reagente líquido concentrado, como um ácido ou base. Informe sua densidade, teor (pureza) e peso equivalente, e deixe em branco o valor que deseja encontrar.`)
};

const pt_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a normalidade de um reagente líquido concentrado, como um ácido ou base. Introduza a densidade, o título (pureza) e o equivalente-grama, e deixe em branco o valor que pretende calcular.`)
};

const ja_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`酸や塩基などの濃縮液体試薬の規定度を求めます。密度、アッセイ（純度）、当量を入力し、求めたい値は空欄のままにしてください。`)
};

const zh_norm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算浓缩液体试剂（如酸或碱）的当量浓度。输入其密度、含量（纯度）和当量重量，将要求解的值留空。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_intro", locale)
	if (locale === "en") return en_norm_intro(inputs)
	if (locale === "es") return es_norm_intro(inputs)
	if (locale === "de") return de_norm_intro(inputs)
	if (locale === "nl") return nl_norm_intro(inputs)
	if (locale === "fr") return fr_norm_intro(inputs)
	if (locale === "it") return it_norm_intro(inputs)
	if (locale === "pt-BR") return pt_br2_norm_intro(inputs)
	if (locale === "pt") return pt_norm_intro(inputs)
	if (locale === "ja") return ja_norm_intro(inputs)
	return zh_norm_intro(inputs)
};